import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const adornmentButtonFn = /* @__PURE__ */ createRecipe('adornmentButton', {}, [])

const adornmentButtonVariantMap = {}

const adornmentButtonVariantKeys = Object.keys(adornmentButtonVariantMap)

export const adornmentButton = /* @__PURE__ */ Object.assign(memo(adornmentButtonFn.recipeFn), {
  __recipe__: true,
  __name__: 'adornmentButton',
  __getCompoundVariantCss__: adornmentButtonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: adornmentButtonVariantKeys,
  variantMap: adornmentButtonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, adornmentButtonVariantKeys)
  },
  getVariantProps: adornmentButtonFn.getVariantProps,
})